import React from 'react';
import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import styles from "./components.module.scss";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";

interface AboutMeCompletedModalProps {
  onClose: (e: React.MouseEvent) => void;
  onCompleteAboutMe: () => void;
}

const AboutMeCompletedModal: React.FC<AboutMeCompletedModalProps> = ({
  onClose,
  onCompleteAboutMe
}) => {
  return (
    <>
      <div className={styles.titleContainer}>
        <div className={styles.popupTitle}>
          Continue without "About Me"?
        </div>
        <CrossButtonBlack
          className={clsx("no-fastclick", styles.crossButtonDark)}
          onClick={onClose}
        />
      </div>
      <div className={styles.description}>
        Complete your "About Me" section to show dental offices how you shine! Profiles with a complete "About Me" section are 20% more likely to be accepted, and give you a chance to show your unique qualities to the dental office.
      </div>
      <br />
      <div className={styles.description}>
        Even if you're not great at writing, we have a writing assistant that can help you craft the perfect way to express yourself.
      </div>
      <br />
      <StyledButton
        variant="contained"
        color="primary"
        size="large"
        onClick={onCompleteAboutMe}
        className={clsx("bigButtonInNewStyle")}
      >
        Complete "About Me"
      </StyledButton>
      <StyledButton
        variant="contained"
        color="primary"
        size="large"
        onClick={onClose}
        className={clsx("bigButtonInNewStyle")}
      >
        I'll do this later
      </StyledButton>
    </>
  );
}

export default AboutMeCompletedModal;